<template>
  <nav
    :class="[
      'nav-bar flex-row align-center',
      { bg, 'white-logo': whiteLogo, 'white-label': whiteLabel, show: visible },
    ]"
  >
    <router-link to="/">
      <img
        draggable="false"
        class="logo"
        src="https://mm2015.mamalaile.com.cn/fb15f0db12b6413c014d8ee5af4900ba.png"
      />
    </router-link>
    <div :class="['tab-block flex-row']">
      <router-link
        v-for="(item, key) in tabList"
        :key="key"
        :to="item.link"
        :class="[
          'tab-item flex-column align-center',
          { active: current == key },
        ]"
        @click="$emit('change', key)"
      >
        {{ item.name }}
      </router-link>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    current: {
      type: String,
      default: "home",
    },
    bg: {
      type: Boolean,
      default: true,
    },
    whiteLabel: {
      type: Boolean,
      default: false,
    },
    whiteLogo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tabList: {
        home: { name: "服务介绍", link: "/" },
        news: { name: "公司动态", link: "/news" },
        about: { name: "关于我们", link: "/about" },
      },
    };
  },

  components: {},

  mounted() { },
});
</script>

<style lang="less" scoped>
.nav-bar {
  width: 100%;
  height: @nav-bar-height;
  z-index: @index-nav-bar;
  position: fixed;
  top: 0;
  left: 0;
  padding: 0 3.13vw;
  transform: translateY(-100%);
  transition: background-color 0.2s ease, transform 0.2s ease;

  &.show {
    transform: translateY(0);
  }

  .logo {
    width: 12.19vw;
    height: auto;
    padding: 0 10px;
  }

  .tab-block {
    margin-left: auto;

    .tab-item {
      position: relative;
      color: #303030;
      font-size: 1.04vw;
      line-height: 1.41vw;
      margin-right: 4.69vw;
      opacity: 0.7;
      transition: color 0.2s ease;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        opacity: 1;
        font-family: @font-am;

        &::after {
          content: "";
          @hr: 0.4vw;
          width: @hr;
          height: @hr;
          position: absolute;
          border-radius: 50%;
          background-color: @color-primary;
          bottom: -0.94vw;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  &.bg {
    background-color: white;
  }

  &.white-logo {
    .logo {
      filter: brightness(500%);
    }
  }

  &.white-label {
    .tab-item {
      color: white;

      &.active {
        &::after {
          filter: brightness(500%);
        }
      }
    }
  }
}
</style>